import { useEffect, useState, useCallback } from "react";
import { API } from "@/App";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Package } from "lucide-react";

const fmt = (d) => d.split("-").reverse().join(".");

export const PackageRequestPanel = ({ businessId, onSell, refreshSignal }) => {
  const [rows, setRows] = useState(null);
  const load = useCallback(async () => {
    const r = await fetch(`${API}/businesses/${businessId}/package-requests`, { credentials: "include" });
    setRows(r.ok ? await r.json() : []);
  }, [businessId]);
  useEffect(() => { load(); }, [load, refreshSignal]);

  return (
    <Card className="border-0 shadow-sm bg-orange-50/60" data-testid="package-request-panel">
      <CardContent className="p-4 space-y-2">
        <p className="text-sm font-semibold text-orange-900">Paket talebi olanlar ({rows?.length ?? "…"})</p>
        <p className="text-xs text-orange-800">Online derse "Paket almak istiyorum" ile katılan ama aktif paketi olmayan kişiler. Paket satınca bekleyen rezervasyonları yeni pakete otomatik bağlanır.</p>
        {(rows || []).map((m) => (
          <div key={m.member_id} className="rounded-xl border border-orange-200 bg-white p-3 flex flex-wrap items-center gap-2" data-testid={`package-request-row-${m.member_id}`}>
            <Package className="w-4 h-4 text-orange-600" />
            <span className="font-medium text-navy">{m.name} {m.surname}</span>
            <span className="text-xs text-grey">{m.phone || ""}</span>
            <span className="text-xs text-orange-800">{m.requested.map((r) => `${fmt(r.date)} ${r.start_time}`).join(" · ")}</span>
            <div className="flex-1" />
            <Button size="sm" className="rounded-lg h-8 bg-orange-600 hover:bg-orange-700" onClick={() => onSell(m)} data-testid={`package-request-sell-${m.member_id}`}>Paket Sat</Button>
          </div>
        ))}
        {rows && !rows.length && <p className="text-sm text-grey py-4 text-center" data-testid="package-request-empty">Paket talebi olan kişi yok.</p>}
      </CardContent>
    </Card>
  );
};
